import { defaultValues } from './default-values';
import { FormSchema } from './form-schema';

export const clientDefaultValues = (campaignName: string): FormSchema => {
  const defaultFields = defaultValues(campaignName, {});

  return {
    ...defaultFields,
    includedSlides: {
      ...defaultFields.includedSlides,
      intro: {
        ...defaultFields.includedSlides.intro,
      },
    },
  };
};
